// Alias
import DefaultFooter from '../../footer';

export default DefaultFooter;
